<template>
  <v-snackbar
    :value="this.$store.getters['notification/getNotificationState'].active"
    :absolute="absolute"
    :bottom="bottom"
    :color="getNotification.color || color"
    :left="left"
    :multi-line="multiLine"
    :right="right"
    :timeout="timeout"
    :top="top"
    :vertical="vertical"
    @input="close"
    @click="executeNotification"
    :class="[getNotification.page && getNotification.mode && 'cursor-pointer']"
  >
    {{ getNotification.text || text }}
    <template v-slot:action="{ attrs }">
      <v-btn v-if="button" :color="buttonText" :text="buttonFlat" @click="close" v-bind="attrs">{{ buttonText }}</v-btn>

      <v-icon v-if="icon" :color="iconColor" @click="close" small v-bind="attrs">{{ iconType }}</v-icon>
    </template>
  </v-snackbar>
</template>

<script>
import { handleLoadRoute } from '@/helpers/page';

import store from '@/store';

export default {
  props: {
    id: { type: String, default: undefined },
    entry: { type: String, default: undefined },
    absolute: { type: Boolean, default: false },
    autoHeight: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false },
    button: { type: Boolean, default: false },
    buttonFlat: { type: Boolean, default: true },
    buttonText: { type: String, default: 'Fechar' },
    buttonColor: { type: String, default: '#FFF' },
    color: { type: String, default: undefined },
    icon: { type: Boolean, default: true },
    iconType: { type: String, default: 'close' },
    iconColor: { type: String, default: '#FFFFFF' },
    left: { type: Boolean, default: false },
    multiLine: { type: Boolean, default: false },
    text: { type: String, default: undefined },
    timeout: { type: Number, default: 6000 },
    top: { type: Boolean, default: true },
    value: { type: [Number, String, Boolean], default: undefined },
    vertical: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    showIconNotification: { type: Boolean, default: false }
  },

  computed: {
    getNotification: () => {
      return store.getters['notification/getNotificationState'].options;
    }
  },

  methods: {
    handleLoadRoute,

    close() {
      store.dispatch('notification/closeNotification');
    },

    async executeNotification() {
      const { page, mode, entry, id, type } = this.getNotification;

      if (!page && !mode) return;

      await store.dispatch('notification/makeReadNotifications', { ids: [id], tab: type });

      await this.handleLoadRoute({ page, mode });

      if (mode !== 'list' && entry) {
        const {
          attributes: {
            attributesTable: { keyValue }
          }
        } = store.getters['page/schema']({ page, mode: 'list' });

        store.dispatch('page/getEntry', { page, mode, entry: { [keyValue]: entry }, changeMode: true });
      }

      this.close();
    }
  }
};
</script>
